import { createTheme } from '@material-ui/core/styles'
import { primary, secondary, white, black } from './colors'

export const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 678,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    fontFamily:
      '"Morrisons-Agenda, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
  palette: {
    type: 'light',
    background: {
      paper: white.white,
      default: white.white,
    },
    common: {
      black: black.black,
      white: white.white,
    },
    text: {
      primary: black.black,
      secondary: black.black,
      disabled: black.black50,
      hint: black.black,
    },
    primary: {
      main: primary.primary,
      dark: primary.dark,
      light: primary.light,
      contrastText: white.white,
    },
    secondary: {
      main: secondary.dark,
      dark: secondary.dark,
      light: secondary.light,
      contrastText: secondary.dark,
    },
  },
})
